import { Component, OnInit, Input, ViewChild, Output ,EventEmitter} from '@angular/core';

import { UsefulLink } from 'app/models/useful-link';
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component';
import { UsefulLinkService } from 'app/services/useful-link.service';
import { CompetitionService } from 'app/services/competition.service';
import { Source } from 'app/models/source.enum';

@Component({
  selector: 'app-modal-useful-link',
  templateUrl: './modal-useful-link.component.html',
  styleUrls: ['./modal-useful-link.component.scss']
})
export class ModalUsefulLinkComponent implements OnInit {

  @ViewChild('modalPanel') modalPanel: ModalPanelComponent;
  @ViewChild('linkForm') linkForm: any;
  @Output() close = new EventEmitter();
  usefulLink: UsefulLink;
  title: string;
  constructor(private usefulLinkService: UsefulLinkService,
    private competitionService: CompetitionService) {
      this.usefulLink =
      new UsefulLink(null,
        this.competitionService.getCompetitionId(),
        null,
        null,
        null,
        Source.UsefulLink,
        false);
   
  }

  ngOnInit() {
  }

  onSave() {
    if (this.usefulLink.id) {
      this.usefulLinkService.update(this.usefulLink)
          .subscribe(res => {this.modalPanel.onClose(); this.close.emit()});
    } else {
        this.usefulLink.createdTime = Date.now();
      this.usefulLinkService.create(this.usefulLink)
          .subscribe(res => {this.modalPanel.onClose(); this.close.emit()});
    }
  }
}
